import React from "react"
import { root } from "../services/Globals"
import uploadAsset from "../api/upload-asset"

export default class SongContainer extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      loading: false,
      loadingMessage: ``,
      data: undefined,
    }
  }

  render = () =>
    this.props.children({
      ...this.state,
      save: this.save,
      delete: this.delete,
    })

  componentDidMount = () => {
    this.props.id && this.fetch()
  }

  componentDidUpdate = previousProps => {
    if (previousProps.id !== this.props.id && !this.state.loading) {
      this.props.id
        ? this.fetch()
        : this.setState({
            data: undefined,
          })
    }
  }

  fetch = () => {
    if (this.props.id) {
      this.setState({ loading: true, loadingMessage: `Loading song` }, () => {
        root.wav
          .api({
            url: `/songs/${ this.props.id }`,
          })
          .then(({ data }) => {
            this.setState({
              loading: false,
              loadingMessage: ``,
              data,
            })
          })
          .catch(error => {
            this.setState({
              loading: false,
              loadingMessage: ``,
              data: undefined,
            })
          })
      })
    }
  }

  save = ({
    id,
    image,
    knownPerformingArtists = [],
    songwriters = [],
    ...data
  }) => {
    const method = id ? `put` : `post`

    const url = { put: `/songs/${ id }`, post: `/songs` }[method]

    const loadingMessage =
      { put: `Saving`, post: `Creating` }[method] + ` song...`

    this.setState(
      {
        loading: true,
        loadingMessage,
      },
      () => {
        Promise.all([
          !image
            ? undefined
            : image.id ||
              uploadAsset(image, ({ loaded, total }) => {
                this.setState({
                  loadingMessage: `Uploading image ${ Math.ceil(
                    (loaded / total) * 100
                  ) }%`,
                })
              }).then(({ id }) => id),
        ])
          .then(([ imageId ]) => {
            this.setState({ loadingMessage })

            return root.wav.api({
              url,
              method,
              data: Object.entries({
                ...data,
                imageId,
                knownPerformingArtistsId: knownPerformingArtists.map(
                  ({ id }) => id
                ),
                songwritersId: songwriters.map(({ id }) => id),
              }).reduce(
                (data, [ key, value ]) =>
                  !!value
                    ? Object.assign(data, {
                        [key]: value,
                      })
                    : data,
                {}
              ),
            })
          })
          .then(response => {
            this.setState(
              {
                loading: false,
                loadingMessage: ``,
                data: response.data,
              },
              () => {
                method === `post` &&
                  this.props.onCreate &&
                  this.props.onCreate(response)
                method === `put` &&
                  this.props.onUpdate &&
                  this.props.onUpdate(response)
              }
            )
          })
          .catch(() => {
            this.setState({
              loading: false,
              loadingMessage: ``,
            })
          })
      }
    )
  }

  delete = () => {
    if (this.props.id) {
      const deleteNotification = new root.wav.Notification({
        text: `<h4 class="ui header"><i aria-hidden="true" class="trash icon"></i><div class="content">You are about to delete this song permanently, would you like to continue?</div></h4>`,
        buttons: [
          root.wav.Notification.button(`Yes`, `ui compact button`, () => {
            this.setState(
              {
                isLoading: true,
                loadingMessage: `Deleting song...`,
              },
              () => {
                deleteNotification.close()

                root.wav
                  .api({
                    url: `/songs/${ this.props.id }`,
                    method: `delete`,
                  })
                  .then(() => {
                    this.setState(
                      {
                        loading: false,
                        loadingMessage: ``,
                        data: undefined,
                      },
                      () => {
                        this.props.onDelete &&
                          this.props.onDelete(this.props.id)
                      }
                    )
                  })
                  .catch(() => {
                    this.setState({
                      loading: false,
                      loadingMessage: ``,
                    })
                  })
              }
            )
          }),
          root.wav.Notification.button(`No`, `ui compact button`, () => {
            deleteNotification.close()
          }),
        ],
        theme: `semanticui`,
        modal: true,
      }).show()
    }
  }
}
